import React, {memo, useState} from 'react';
import PropTypes from 'prop-types';
import styles from './checkbox.module.scss';
import InfoIcon from '@/assets/icons/information.svg';

const CheckboxComponent = ({text, name = '', className = '', checked, tip, ...props}) => {
  const [info, setInfo] = useState(false);

  return (
      <label className={`${styles.cgCheckbox} ${className}`}><div className={`${styles.cgCheckbox__label}`}>{text}</div>
      <input name={name} type="checkbox" checked={checked} {...props}/>
      <span className={styles.cgCheckmark}></span>
      {tip && <InfoIcon className='ml-1'
        onMouseEnter={() => setInfo(true)}
        onMouseLeave={() => setInfo(false)}/>}
      {info && <p className={styles.cgCheckmark__info}>{tip}</p>}
    </label>
  );
};

CheckboxComponent.propTypes = {
  text: PropTypes.string.isRequired,
  className: PropTypes.string,
  name: PropTypes.string,
  checked: PropTypes.bool,
  onChange: PropTypes.func,
  tip: PropTypes.string,
};

export default memo(CheckboxComponent);
